export const expertise_area_level1 = [
    {
        "text": "交通事故",
        "value": "交通事故"
    },
    {
        "text": "公司事务",
        "value": "公司事务"
    },
    {
        "text": "刑事辩护",
        "value": "刑事辩护"
    },
    {
        "text": "劳动纠纷",
        "value": "劳动纠纷"
    },
    {
        "text": "医疗纠纷",
        "value": "医疗纠纷"
    },
    {
        "text": "合同纠纷",
        "value": "合同纠纷"
    },
    {
        "text": "婚姻家庭",
        "value": "婚姻家庭"
    },
    {
        "text": "房产纠纷",
        "value": "房产纠纷"
    },
    {
        "text": "拆迁安置",
        "value": "拆迁安置"
    },
    {
        "text": "涉外纠纷",
        "value": "涉外纠纷"
    },
    {
        "text": "知识产权",
        "value": "知识产权"
    },
    {
        "text": "经济纠纷",
        "value": "经济纠纷"
    },
    {
        "text": "行政纠纷",
        "value": "行政纠纷"
    },
    {
        "text": "侵权纠纷",
        "value": "侵权纠纷"
    }
];